import { Divider, Form, FormInstance, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';
import { InputFileDragger } from '../../../Common/InputFileDragger';

interface ArticleAuthorFieldsProps {
  form: FormInstance;
  defaultFileLocation?: string;
}

export default function ArticleAuthorFields({ form, defaultFileLocation }: ArticleAuthorFieldsProps) {
  return (
    <>
      <Divider orientation="left">Author</Divider>
      <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr' }}>
        <InputFileDragger
          name="authorImageId"
          uploadEndText="Author Image. Preferably square form"
          form={form}
          displayDescription={false}
          defaultFileLocation={defaultFileLocation}
          required={false}
          rules={[{ required: false, message: 'Please select image' }]}
          allowDelete
        />
      </div>
      {/* rules={[{ required: true }]} */}
      <Form.Item label="Name" name="authorName">
        <Input placeholder="Author name" maxLength={100} />
      </Form.Item>
      <Form.Item label="Description" name="authorDescription">
        <TextArea placeholder="Author description" maxLength={500} />
      </Form.Item>
    </>
  );
}
